// skipcq: JS-W1028
import { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { GoogleMapsOverlay } from '@deck.gl/google-maps';
import { HeatmapLayer } from '@deck.gl/aggregation-layers';

function FirstTouchHeatmapOverlay({ map, weightedLocations }) {
  const overlay = useMemo(
    () => new GoogleMapsOverlay({ interleaved: false }),
    [],
  );

  useEffect(() => {
    return () => {
      overlay.finalize();
    };
  }, [overlay]);

  useEffect(() => {
    overlay.setMap(map);
    return () => {
      overlay.setMap(null);
    };
  }, [map, overlay]);

  useEffect(() => {
    if (weightedLocations.length === 0) {
      overlay.setProps({ layers: [] });
      return;
    }

    overlay.setProps({
      layers: [
        new HeatmapLayer({
          id: 'first-touch-hotspots-heatmap',
          data: weightedLocations,
          getPosition: (entry) => [entry.location.lng, entry.location.lat],
          getWeight: (entry) => entry.weight,
          radiusPixels: 28,
        }),
      ],
    });
  }, [overlay, weightedLocations]);

  return null;
}

FirstTouchHeatmapOverlay.propTypes = {
  map: PropTypes.object.isRequired,
  weightedLocations: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default FirstTouchHeatmapOverlay;
